// Shared with 응답 관리: keep its normalization and multiple-choice set comparison.
const normalizeText = text => (text ?? '').toString().normalize('NFKC').toLowerCase().replace(/[^0-9a-z\uac00-\ud7a3]/gi, '');
const squashEtc = value => typeof value === 'string' && value.startsWith('기타|') ? '기타' : value;
const toTokenSet = value => new Set((Array.isArray(value) ? value : [value])
    .flatMap(item => String(item).split(/[,|/;]+/))
    .map(squashEtc).map(item => normalizeText(String(item).trim())).filter(Boolean));

export function judgeCorrectAnswer(userAnswers, correctAnswer, typeId) {
    if (correctAnswer == null || String(correctAnswer).trim() === '') return null;
    if (Number(typeId) === 4) {
        const actual = toTokenSet(userAnswers), expected = toTokenSet(correctAnswer);
        if (actual.size !== expected.size) return false;
        for (const answer of actual) if (!expected.has(answer)) return false;
        return true;
    }
    return normalizeText(Array.isArray(userAnswers) ? userAnswers.join(' ') : userAnswers) === normalizeText(correctAnswer);
}
